export enum BiometricContextsEnum {
  ACTIVATE_CARD = 'ACTIVATE_CARD',
  CANCEL_CHALLENGE = 'CANCEL_CHALLENGE',
  CHALLENGE_PAGE = 'CHALLENGE_PAGE',
  CHANGE_ACCESS_KEY = 'CHANGE_ACCESS_KEY',
  CHANGE_ADDRESS = 'CHANGE_ADDRESS',
  CHANGE_EMAIL = 'CHANGE_EMAIL',
  CHANGE_IBAN = 'UPDATE_MAIN_CHARGE_ACCOUNT_AND_PAYMENT_METHOD',
  CHANGE_PHONE = 'CHANGE_PHONE',
  CHANGE_PIN = 'CHANGE_PIN',
  CHANGE_SIGNATURE_KEY = 'CHANGE_SIGNATURE_KEY',
  CHANGE_3D_SECURE = 'CHANGE_3DS',
  CHECK_3D_SECURE = 'CHECK_3DS',
  CREDIT_LIMIT = 'LIMIT_INCREASE',
  DASHBOARD = 'HOME_PAGE',
  DEFAULT_CONTEXT = 'DEFAULT_CONTEXT',
  DEPOSIT_MONEY = 'DEPOSIT_MONEY',
  DEVICE_MANAGER_LIST = 'DEVICE_MANAGER_LIST',
  DEVICE_MANAGER_UNROL = 'DEVICE_MANAGER_UNROL',
  DEVICE_MANAGER_BLOCK_UNBLOCK = 'DEVICE_MANAGER_BLOCK_UNBLOCK',
  FAST_CASH = 'FAST_CASH',
  LOGIN_PAGE = 'LOGIN_PAGE',
  LOGIN_CREDENTIALS = 'CREDENTIALS_LOGIN',
  RECOVER_ACCESS_KEY = 'RECOVER_ACCESS_KEY',
  RECOVER_SIGNATURE_KEY = 'RECOVER_SIGNATURE_KEY',
  REQUEST_NEW_CARD = 'REQUEST_NEW_CARD',
  SECURITY_LANDING = 'SECURITY_LANDING',
  SUCCESS_OPERATION = 'SUCCESS_OPERATION',
  UPDATE_PAYMENT_METHOD = 'UPDATE_PAYMENT_METHOD',
  UNSUCCESSFUL_OPERATION = 'UNSUCCESSFUL_OPERATION',
  VIEW_CVV = 'VIEW_CVV',
  VIEW_PIN = 'VIEW_PIN',
}
